import React from 'react'
import clsx from 'clsx'

// Cube
import { classToFComponent, type FCClassContext } from 'cube-react'

import Sel from './styles-consts'
import GradeRowView from './v-grade-row'

import { GradeScope } from '../analise-reacoes.scope'

export type GradeProps = {
    className?: string
    scope: GradeScope
}

class GradeViewClass implements FCClassContext<GradeProps> {
    scope!: GradeScope

    render({ className, scope }: GradeProps) {
        this.scope = scope

        return (
            <div className={clsx(Sel.brCard, className)}>
                <div className={Sel.brCardContent}>
                    <div className={Sel.dFlexH}>
                        <span className={clsx(Sel.textUp02, Sel.textWeightSemiBold)}>Notificações de Reações Adversas</span>
                        <span className={Sel.textBase}>
                            <span>• Período de análise: {scope.periodoDeAnalise}</span>
                            <span>• Clique para expandir detalhes das reações</span>
                        </span>
                    </div>
                    <br />
                    <table className={Sel.consultaReacoesGrade}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Medicamento (WHO Drug)</th>
                                <th>Status Conferência</th>
                                <th>Gravidade</th>
                                <th>Casos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {scope.rows.map((rowScope) => (
                                <GradeRowView key={rowScope.uid} scope={rowScope} />
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default classToFComponent(GradeViewClass)
